import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as AWS from 'aws-sdk';
import { configData } from "../../../../../src/config/systemconfigurationconstants";
import { ToastContainer, toast } from "react-toastify";
import { useEncryption } from '../../../../customHooks/useEncryption';
const RuleTemplateDownload = ({ show, handleClose, usecaselistforDownloadTemplate }) => {
  const [dotloader, setDotLoader] = useState(false);
  const [usecase, setUsecase] = useState("");
  const [usecasename, setUsecasename] = useState("");
  const [client, setClient] = useState("");
  const [clientname, setClientname] = useState("");
  const [clientList, setClientList] = useState([]);
  const { encrypt, decrypt } = useEncryption();
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  };
  const handleUsecaseChange = (value) => {
    setUsecase(value);
    let selectedUsecase = usecaselistforDownloadTemplate.find(x => x.UseCaseId == value);
    setUsecasename(selectedUsecase.UCSN)
    let getClientListUnderSelectedUseCase = selectedUsecase ? selectedUsecase.Client : [];
    setClientList(getClientListUnderSelectedUseCase)
  }
  const handleclientchange = (e) => {
    setClient(e.target.value);
    let getclientname = clientList.find(x => x.ClientID == e.target.value)
    setClientname(getclientname.CSN)
  }
  const handleClosedownloadtemplate = () => {
    setUsecase("");
    setClient("");
    handleClose();
  }
  const downloadtemplate = async () => {
    setDotLoader(true);
    const lambda = new AWS.Lambda({
      region: configData.LAMBDA_REGION,
      accessKeyId: decrypt(getCookie('ak')),
      secretAccessKey: decrypt(getCookie('sk')),
      // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
      httpOptions: {
        timeout: 180000
      }
    });
    // Disable SDK-level retries for all AWS services
    AWS.config.update({
      maxRetries: 0
    });

    const payloadData = {
      Command: configData.RULE_TEMPLATE_DOWNLOAD,
      ClientId: client,
      UseCaseId: usecase,
      SecurityId: "",
      SecurityToken: localStorage.getItem("SecurityToken"),
      EventContextId: "",
      CallerSourceId: "",
      CallerSourceName: ""
    };

    const params = {
      FunctionName: configData.LAMBDA_FUNCTION_NAME1,
      Payload: JSON.stringify(payloadData)
    };
    try {
      // Wrap lambda.invoke in a Promise to use await
      const lambdaResponse = await new Promise((resolve, reject) => {
        lambda.invoke(params, (err, data) => {
          if (err) reject(err);
          else resolve(data);
        });
      });

      const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
      const parsedBody = JSON.parse(parsedPayload.body);
      if (parsedBody.Status === true) {
        downloadTemplate(parsedBody.Output);
        setTimeout(() => {
          setDotLoader(false);
        }, 1000);
      }
      else {
        toast.error("Report Downloaded Failed", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setTimeout(() => {
          setDotLoader(false);
        }, 1000);
      }
    } catch (error) {
      toast.error("Report Downloaded Failed", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setTimeout(() => {
        setDotLoader(false);
      }, 1000);
      console.error('Error in getCurrentRpm:', error);
    }
  }
  const downloadTemplate = (json) => {
    AWS.config.credentials = new AWS.Credentials({
      accessKeyId: decrypt(getCookie('ak')),
      secretAccessKey: decrypt(getCookie('sk'))
    });
    const params = {
      Bucket: json.Bucket,
      Key: json.FileName,
      Expires: 300 // The URL will now expire in 5 minutes (300 seconds)
    };
    const s3 = new AWS.S3({
      region: 'us-east-1',
    });
    var url = s3.getSignedUrl('getObject', params);
    window.open(url, '_blank');
    handleClosedownloadtemplate();
    toast.success("template Downloaded Successfully", {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }
  // const callAddNewFormField = async()=>{
  //   const lambda = new AWS.Lambda({
  //     region: configData.LAMBDA_REGION,
  //     accessKeyId: configData.BASE_ACCESS_KEY_ID,
  //     secretAccessKey: configData.BASE_SECRET_ACCESS_KEY
  //   });

  //   const payloadData = {
  //     Command: configData.ADD_NEW_FORM_FIELDSINFO_FOR_TEMPLATE,
  //     ClientId: client,
  //     UseCaseId: usecase,
  //     SecurityId: "",
  //     SecurityToken: localStorage.getItem("SecurityToken"),
  //     EventContextId: "",
  //     CallerSourceId: "",
  //     CallerSourceName: ""
  //   };

  //   const params = {
  //     FunctionName: configData.LAMBDA_FUNCTION_NAME1,
  //     Payload: JSON.stringify(payloadData)
  //   };
  //   try {
  //     // Wrap lambda.invoke in a Promise to use await
  //     const lambdaResponse = await new Promise((resolve, reject) => {
  //       lambda.invoke(params, (err, data) => {
  //         if (err) reject(err);
  //         else resolve(data);
  //       });
  //     });

  //     const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
  //     if (parsedPayload.statusCode === 200) {
  //       const parsedBody = JSON.parse(parsedPayload.body);
  //       const parsedoutput = JSON.parse(parsedBody.Output)
  //       console.log(JSON.parse(parsedBody.Output))
  //       callAddNewFormField();
  //       // ExcelRuleConfigInfoForUpload = parsedoutput.ExcelRuleConfigInfo
  //       // usecaseInfoForUpload = parsedoutput.UseCaseClientInfo
  //       // setUsecaseInfo(parsedoutput.UseCaseClientInfo)
  //       // setExcelRuleConfigInfo(parsedoutput.ExcelRuleConfigInfo)
  //       // console.log(parsedoutput.UseCaseClientInfo)
  //       // console.log(parsedoutput.ExcelRuleConfigInfo)
  //       // console.log(ExcelRuleConfigInfoForUpload)
  //       // console.log(usecaseInfoForUpload)
  //     }
  //     else {
  //       // setDotLoader(false);
  //     }
  //   } catch (error) {
  //     // setDotLoader(false);
  //     console.error('Error in getCurrentRpm:', error);
  //   }
  // }
  return (
    <>
      <Modal show={show} onHide={handleClosedownloadtemplate} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Rule Template Download</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dotloader ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }}>
              <div className="loader"></div>
            </div>
          ) : (
            <Form>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="3">
                  Usecase Name
                </Form.Label>
                <Col sm="9">
                  <Form.Select
                    size="sm"
                    value={usecase}
                    onChange={(e) => handleUsecaseChange(e.target.value)}
                  >
                    <option value="" disabled>Select Usecase</option>
                    {usecaselistforDownloadTemplate?.length > 0 &&
                      usecaselistforDownloadTemplate.map((el) => (
                        <option key={el.UseCaseId} value={el.UseCaseId}>
                          {el.UseCaseName}
                        </option>
                      ))}
                  </Form.Select>
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-1">
                <Form.Label column sm="3">
                  Client
                </Form.Label>
                <Col sm="9">
                  <Form.Select
                    size="sm"
                    value={client}
                    onChange={handleclientchange}
                  >
                    <option value="">Select Client</option>
                    {clientList?.length > 0 &&
                      clientList.map((option, idx) => (
                        <option key={idx} value={option.ClientID}>
                          {option.ClientName}
                        </option>
                      ))}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        {!dotloader && (
          <Modal.Footer>
            <Button variant="secondary" size="sm" onClick={handleClosedownloadtemplate}>
              Close
            </Button>
            <Button variant="primary" size="sm" onClick={downloadtemplate} disabled={!usecase || !client}>
              Download
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>

  );
};

export default RuleTemplateDownload;